import { capitalize } from "pages/expenses/utils";

export const fieldNameLabelFormat = (fieldName: string) => {
  return capitalize(fieldName.replace(/([A-Z])/g, " $1").toLowerCase());
};
